module.exports = __webpack_public_path__ + "media/images/email/delete-fd79fc9c5c82a0750c90045372690551.svg";